import store from '@/services/store';

export default (defaultLayout = 'div') => (
  (to, from, next) => {
    store.dispatch('layout/setCurrentLayout', to.meta.layout ?? defaultLayout);

    next();
  }
);
